// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__ZU4T0","sm":"textarea_sm__1b6hn","disabled":"textarea_disabled__9r2fc"};